import {Field} from 'formik';


import {
    FormikTextarea,
    FormikTextInput,
    PlatformFieldset
} from '@flexinet/ui-components';
import {Stack} from "@mantine/core";


export const FormComponent = () => {

    return (
        <Stack gap={'xl'}>
            <PlatformFieldset legend='Customer'>

                <Field
                    name='name'
                    label='Name'
                    description='Please enter the application name'
                    component={FormikTextInput}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='email'
                    label='Email'
                    description='Please enter custmoer email'
                    component={FormikTextInput}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='phone'
                    label='Phone'
                    description='Please enter customer phone number'
                    component={FormikTextInput}
                    my={'xl'}
                />

                <Field
                    name='description'
                    label='Description'
                    description='Please enter custome description'
                    component={FormikTextarea}
                    my={'xl'}
                />


            </PlatformFieldset>


        </Stack>
    );
};
